import {User, UserSessionService} from '@rbaip/ui-component';
import {permissionType} from './permission.config';

export class PermissionUtils {

  public static hasPermission(userSessionService: UserSessionService, permissionName: string): boolean {
    if (!permissionName) { return false; }
    if (permissionName === permissionType.noSpecialPermission) { return true; }

    const currentUser = userSessionService.getCurrentUser();
    return !!currentUser && currentUser.hasRole(permissionName);
  }

  public static hasSitePermission(userSessionService: UserSessionService, permissionName: string, siteId: number): boolean {
    if (!permissionName) { return false; }
    if (!siteId) { return false; }

    const currentUser = userSessionService.getCurrentUser();
    return !!currentUser && PermissionUtils.hasSiteRole(currentUser, siteId, permissionName);
  }

  private static hasSiteRole(currentUser: User, siteId: number, roleName: string): boolean {
    if (currentUser['siteUserPermission']) {
      const thisSitePermission = currentUser['siteUserPermission'][siteId]['siteLevelPermission'];
      return thisSitePermission && thisSitePermission[roleName];
    }
    return false;
  }
}
